import { Tag } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

/**
 * Styled tag for side column
 */
export const StyledSideTag = styled(Tag)(({ theme }) => ({
  padding: '0px',
  fontSize: theme.typography.pxToRem(10),
}));

/**
 * Styled tag for status column
 */
export const StyledStatusTag = styled(Tag)(({ theme }) => ({
  padding: '0px',
  fontSize: theme.typography.pxToRem(11),
}));
